import { Component, Input, OnInit , ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { DataService } from 'src/app/services/data.service';
import { WizardStateService } from '../../services/wizard-state.service';

@Component({
    selector: 'app-world-builder-abort-confirm-modal',
    templateUrl: './world-builder-abort-confirm-modal.component.html',
    styleUrls: ['./world-builder-abort-confirm-modal.component.scss'],
    standalone: false
})
export class WorldBuilderAbortConfirmModalComponent implements OnInit {

  @Input() mapId?: string;
  private userId: any = null;
  isCancelling = false;

  constructor(public activeModal: NgbActiveModal,
    private stateService: WizardStateService,
    private currentUserService: CurrentUserService,
    private dataService: DataService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.currentUserService.currentUser.pipe(take(1)).subscribe((user) => {
      if (user) {
        this.userId = user.id ?? user.user_id;
      }
    
          this.cdr.detectChanges();});

    if (!this.userId) {
      try {
        const stored = localStorage.getItem('currentUser');
        if (stored) {
          const userObj = JSON.parse(stored);
          this.userId = userObj?.id ?? userObj?.user_id;
        }
      } catch (e) {
        console.warn('Could not read currentUser from localStorage', e);
      }
    }
  }

  confirm() {
    const state = this.stateService.currentState;
    const mapId = this.mapId || state.mapId;
    const userId = this.userId;

    // Only cancel upload if it is a fresh map (not a preset existing map)
    // and the backend upload process is actively in progress
    const shouldCancel = !state.mapIdPreset && !!state.isUploadInProgress && !!mapId;

    if (shouldCancel && userId) {
      this.isCancelling = true;
      this.dataService.cancelMapUpload(mapId, userId).subscribe({
        next: () => {
          this.isCancelling = false;
          this.activeModal.close(true);
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.warn('Error cancelling map upload:', err);
          this.isCancelling = false;
          this.activeModal.close(true);
        
          this.cdr.detectChanges();}
      });
    } else {
      this.activeModal.close(true);
    }
  }

  cancel() {
    this.activeModal.close(false);
  }

}
